import { LDReactOptions } from 'launchdarkly-react-client-sdk';

export const LD_REACT_OPTIONS: LDReactOptions = {
  // Converts all flag names to camel case
  useCamelCaseFlagKeys: true,
  // Sends telemetry info to LD every time a flag is requested
  sendEventsOnFlagRead: true,
};
